var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 207 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5858_8326)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5926 47.0517L149.913 24.8968L151.726 36.8193C164.389 34.2293 176.465 44.0371 178.698 58.7258C180.931 73.4144 172.476 87.4216 159.812 90.0116L160.509 94.5971L160.508 94.5974C160.532 94.7499 160.556 94.9027 160.579 95.0557C165.853 129.751 145.881 162.837 115.969 168.955C86.0567 175.073 57.5325 151.906 52.2581 117.211C52.2349 117.058 52.2121 116.905 52.1898 116.752L52.1884 116.752L51.4913 112.167C38.8279 114.757 26.7519 104.949 24.519 90.2601C22.286 75.5715 30.7416 61.5643 43.4051 58.9742L41.5926 47.0517ZM45.357 71.8137C38.8069 73.1534 34.4333 80.3984 35.5883 87.996C36.7433 95.5936 42.9895 100.667 49.5395 99.3269L45.357 71.8137ZM157.86 77.172C164.41 75.8323 168.784 68.5873 167.629 60.9897C166.474 53.3921 160.228 48.3191 153.678 49.6588L157.86 77.172Z",
    fill: "#FFC629"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5684 43.1709L70.3276 107.368L70.3291 107.368C70.3514 107.521 70.3742 107.674 70.3974 107.827C75.6718 142.522 104.196 165.689 134.108 159.571C135.272 159.333 136.421 159.054 137.554 158.736C131.266 163.75 123.973 167.318 115.969 168.955C86.0567 175.073 57.5325 151.906 52.2581 117.211C52.2348 117.058 52.2121 116.905 52.1898 116.752L52.1883 116.752L41.5926 47.052L60.5684 43.1709Z",
    fill: "#FFE166"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.603 92.9948L130.844 28.7971L149.82 24.916L160.415 94.6163L160.414 94.6165C160.438 94.7691 160.462 94.9218 160.485 95.0748C165.401 127.409 148.389 158.345 121.84 167.358L124.269 183.333L111.618 185.92L109.177 169.864C103.48 170.216 97.8954 169.53 92.5791 167.935C93.7373 167.784 94.8989 167.591 96.0626 167.353C125.975 161.235 145.947 128.149 140.673 93.4533C140.65 93.3003 140.626 93.1476 140.602 92.9951L140.603 92.9948Z",
    fill: "#FFB018"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 110.563,
    height: 47.3099,
    transform: "matrix(0.979718 -0.200382 0.150293 0.988642 64.1785 195.623)",
    fill: "#6F200E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.9476,
    height: 47.3099,
    transform: "matrix(0.979718 -0.200382 0.150293 0.988642 155.895 176.864)",
    fill: "#501508"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90.3874,
    height: 28.757,
    transform: "matrix(0.979718 -0.200382 0.150293 0.988642 76.6418 202.531)",
    fill: "#FFC629"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.282,
    height: 20.4082,
    transform: "matrix(0.979718 -0.200382 0.150293 0.988642 81.153 205.39)",
    fill: "#FFE166"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5858_8326",
    x: 0.161377,
    y: 0.896851,
    width: 203.448,
    height: 265.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5858_8326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5858_8326",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.2b9e5a85.svg";
export { ForwardRef as ReactComponent };